import "./LargeImageElement.less";

export class LargeImageElement extends HTMLElement {
    static tag = "large-image";

    connectedCallback() {
        this.addEventListener("click", this.remove);
    }
}

customElements.define(LargeImageElement.tag, LargeImageElement);